import React from 'react';
import { createForm } from 'rc-form';
import { withStyles } from '@material-ui/core/styles';
import { useSelector } from 'react-redux';
// eslint-disable-next-line import/no-extraneous-dependencies
import get from 'lodash/get';
import {
    Grid,
    Typography,
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    FormControlLabel,
} from '@material-ui/core';

import { selectSystemPagesV2Enabled } from 'Console/data/applicationDetail/settings/SettingsSelector';

import FormCheckbox from 'Console/components/common/form/FormCheckbox';
import FormInput from 'Console/components/common/form/FormInput';

const styles = (theme) => ({
    subtitle: {
        paddingLeft: theme.typography.pxToRem(34),
        color: 'gray',
        marginTop: theme.typography.pxToRem(-11),
        fontSize: theme.typography.pxToRem(12),
    },
    row: {
        marginBottom: theme.typography.pxToRem(15),
    },
    urlMatchInput: {
        marginLeft: theme.typography.pxToRem(35),
        marginRight: theme.typography.pxToRem(35),
    },
});

const TourSettingDialog = ({
    intl,
    classes,
    guide,
    closeEditGuide,
    form,
    form: { getFieldValue, getFieldsValue },
    consoleLanguage,
    onSave,
}) => {
    const systemPagesV2Enabled = useSelector(selectSystemPagesV2Enabled);

    if (!guide) return null;

    const handleSaveTour = () => {
        const formData = {
            ...getFieldsValue(),
            pattern: !systemPagesV2Enabled ? getFieldValue('pattern') : 'NO_PATTERN',
            matchUrl: !systemPagesV2Enabled ? getFieldValue('matchUrl') : false,
        };
        closeEditGuide();
        onSave(guide, formData);
    };

    return (
        <Dialog
            id="yeself-guide-setting-dialog"
            onClose={closeEditGuide}
            aria-labelledby="Guide setting dialog"
            open={Boolean(guide)}
        >
            <DialogTitle id="yeself-guide-setting-title">
                {guide.name[consoleLanguage]} Settings
            </DialogTitle>
            <DialogContent id="yeself-guide-setting-content">
                {!systemPagesV2Enabled && (
                    <>
                        <Grid container direction="row" alignItems="center" className={classes.row}>
                            <FormControlLabel
                                control={
                                    <FormCheckbox
                                        id="yeself-guide-setting-checkbox"
                                        initialValue={get(
                                            guide,
                                            'graph.metadata.contextHelp.matchUrl',
                                            false
                                        )}
                                        form={form}
                                        formItemKey="matchUrl"
                                    />
                                }
                                label={intl.formatMessage({ id: 'ContextHelp.tours.matchUrlText' })}
                            />

                            <Typography className={classes.subtitle}>
                                {intl.formatMessage({ id: 'ContextHelp.tours.matchUrlHelpText' })}
                            </Typography>
                        </Grid>
                        <Grid className={`${classes.row} ${classes.urlMatchInput}`}>
                            <FormInput
                                fullWidth={false}
                                form={form}
                                type="text"
                                initialValue={get(guide, 'graph.metadata.contextHelp.pattern') || ''}
                                formItemKey="pattern"
                                placeholder="URL match pattern"
                                disabled={!getFieldValue('matchUrl')}
                            />
                        </Grid>
                    </>
                )}
                <Grid container direction="row" alignItems="center">
                    <FormControlLabel
                        control={
                            <FormCheckbox
                                id="yeself-guide-setting-checkbox"
                                initialValue={
                                    get(guide, 'graph.metadata.contextHelp.matchElement') || false
                                }
                                form={form}
                                formItemKey="matchElement"
                            />
                        }
                        label={intl.formatMessage({ id: 'ContextHelp.tours.matchElement' })}
                    />
                </Grid>
            </DialogContent>
            <DialogActions id="yeself-guide-settings-dialog-buttons">
                <Button onClick={closeEditGuide} color="primary">
                    {intl.formatMessage({ id: 'Buttons.cancel' })}
                </Button>

                <Button color="primary" onClick={handleSaveTour}>
                    {intl.formatMessage({ id: 'Buttons.save' })}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default createForm()(withStyles(styles)(TourSettingDialog));
